module.exports = __webpack_public_path__ + "img/Refresh Icon - white.4294d836.svg";